/*
 * @Author: wangyan1
 * @Description:
 * @Date: 2022-04-25 17:07:00
 * @LastEditTime: 2022-04-25 17:08:00
 * @FilePath: /teacher-xkh-web/src/service/common/index.js
 */
import http from '../http'
import url from './index-url'
const { get, post } = http

export default {
  getBaseData() {
    return get(url.getBaseData)
  },
  getGradeList() {
    return get(url.getGradeList)
  },
  clashQuery() {
    return get(url.clashQuery)
  },
  clashRead(data) {
    return post(url.clashRead, data)
  },
  lessonList(data) {
    return get(url.lessonList, data)
  },
  getQRcodeStr(data) {
    return get(url.getQRcodeStr, data)
  }
  // getSubjectAndGrade() {
  //   return get(url.getSubjectAndGrade)
  // }
}